var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from 'react-router-dom';
import SignupForm from '../Auth/SignupForm';
var SignupPage = function () {
    var navigate = useNavigate();
    return (_jsxs("div", __assign({ className: "min-h-screen bg-gradient-to-br from-purple-50 via-white to-blue-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 flex flex-col" }, { children: [_jsx("header", __assign({ className: "w-full p-4 lg:p-6" }, { children: _jsx("div", __assign({ className: "max-w-6xl mx-auto flex items-center justify-center" }, { children: _jsxs("div", __assign({ className: "flex items-center space-x-2" }, { children: [_jsx("img", { src: "/logo.png", alt: "LectureLearn", className: "h-8 w-8", onError: function (e) {
                                    e.currentTarget.style.display = 'none';
                                } }), _jsx("span", __assign({ className: "text-xl font-bold text-foreground dark:text-white" }, { children: "LectureLearn" }))] })) })) })), _jsx("main", __assign({ className: "flex-1 flex items-center justify-center p-4 lg:p-6 overflow-y-auto" }, { children: _jsx("div", __assign({ className: "w-full max-w-md my-8" }, { children: _jsx(SignupForm, { onSwitchToLogin: function () { return navigate('/login'); }, onClose: function () { return navigate('/'); } }) })) }))] })));
};
export default SignupPage;
